import {
  HASH_HOME_ABOUT,
  HASH_HOME_TESTIMONIES,
  HASH_HOME_SPIRIT,
  HASH_HOME_EXERCISE,
  HASH_HOME_NUTRITION,
  HASH_HOME_MINDSET
} from 'routes/routes';

export default [
  { text: 'About', route: HASH_HOME_ABOUT },
  { text: 'Testimonies', route: HASH_HOME_TESTIMONIES },
  { text: 'Spirit', route: HASH_HOME_SPIRIT },
  { text: 'Mindset', route: HASH_HOME_MINDSET },
  { text: 'Nutrition', route: HASH_HOME_NUTRITION },
  { text: 'Exercise', route: HASH_HOME_EXERCISE }
];
